<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ywfWoB/tc-custom/9781504058919.jpg?1706039160224" alt="This image is the cover for the book Mrs. Dalloway"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mrs. Dalloway
      </h1>
      <p class="bookDescription body article font2">
        <b>This masterpiece of modern literature by the author of <i>Orlando</i> is an intimate and probing account of a single day in the life of a London society woman.</b><br/><br/> It’s the spring of 1923 and Clarissa Dalloway must prepare her Westminster home for the guests she will receive this evening. As the wife of a Parliament Minister, proper decorum is of upmost importance, and she decides to buy the flowers herself. Walking through the streets of London, Clarissa’s entire life swirls through her mind as Big Ben tolls out the passing hours of the day.<br/>  <br/> On her journey, Clarissa will encounter friends and memories; regrets and dreams of what might have been. From her happy youth to the realities of World War I and the very logical reasons for marrying her husband, her stream of consciousness is evoked with lucidity and depth by one of the twentieth century’s most important literary stylists.<br/>  <br/> Virginia Woolf’s <i>Mrs. Dalloway </i>is “conceived so brilliantly, dimensioned so thoroughly and documented so absolutely that her type, in the words of Constantin Stanislavsky, might be said to have been done ‘inviolably and for all time’” (<i>The New York Times</i>).<br/>  <br/> “Virginial Woolf is one of the few writers who changed life for all of us. Her combination of intellectual courage and painful emotional sensitivity created a new way of perceiving and living in the world.” —Margaret Drabble<br/>  <br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Woolf
      </h2>
      
      <p class="authorDescription body article"> Virginia Woolf (1882&ndash;1941), an English modernist, has been heralded as one of the greatest female writers of all time. In 1915, she published her first novel, <I>The Voyage Out</I>, which became known for its peculiar narrative perspectives and free-association prose. She followed this up with several famous novels such as <I>Mrs. Dalloway</I> and<I> Jacob&rsquo;s Room</I>, as well as the feminist essay <I>A Room of One&rsquo;s Own</I>. Woolf suffered from depression and committed suicide in 1941. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publisher
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ae9dd7a